import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'src/styles/media';

import Container from 'components/Container';
// import Hotspot from './Hotspot';

// import { hotspots, features } from 'src/data/sitemap';
import { features } from 'src/data/sitemap';

class Sitemap extends Component {
  state = {
    activeFeature: null,
  };

  static propTypes = {
    features: PropTypes.array,
  };

  handleEnterHotspot = index => {
    this.setState({ activeFeature: index });
  };

  handleLeaveHotSpot = () => {
    this.setState({ activeFeature: null });
  };

  render() {
    return (
      <Root>
        <Container>
          <Title>Grand Amenities</Title>
        </Container>
        <Map>
          <Overlay active={this.state.activeFeature !== null} />
          {/* {hotspots.map((hotspot, index) => {
            return (
              <Hotspot
                key={index}
                x={hotspot.location[0]}
                y={hotspot.location[1]}
                onMouseEnter={() => {
                  this.handleEnterHotspot(index);
                }}
                onMouseLeave={this.handleLeaveHotSpot}
                active={this.state.activeFeature === index}
              >
                {hotspot.caption}
              </Hotspot>
            );
          })} */}
        </Map>
        <FeaturesMobile>
          <Container>
            <ul>
              {features.map(feature => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
          </Container>
        </FeaturesMobile>
      </Root>
    );
  }
}

const Root = styled.div`
  position: relative;
`;

const Map = styled.div`
  padding-top: 56%;
  background-image: url(${require('src/assets/images/amenities/sitemap.jpg')});
  background-size: cover;
`;

const Title = styled.h2`
  position: absolute;
  left: 20px;
  top: 20px;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
  z-index: 10;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${props => (props.active ? '1' : '0')};
  transition: all 0.5s;
`;

const FeaturesMobile = styled.div`
  padding-top: 30px;
  display: none;
  @media (max-width: ${media.md}) {
    display: block;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    padding-left: 15px;
    li {
      width: 50%;
      padding-left: 10px;
      color: ${({theme}) => theme.colorPrimary};
      font-size: 10px;
      font-family: ${({theme}) => theme.fontMedium};
      line-height: 2;
      text-transform: uppercase;
    }
  }
  padding-bottom: 30px;
`;

export default Sitemap;



// WEBPACK FOOTER //
// ./src/pages/Amenities/elements/Sitemap.js